export default __webpack_public_path__ + "static/media/largevan-nav-completed.ffb09cf3.svg";